import { render } from "./CustomTabPanel.vue?vue&type=template&id=61daa2ce&scoped=true"
import script from "./CustomTabPanel.vue?vue&type=script&lang=js"
export * from "./CustomTabPanel.vue?vue&type=script&lang=js"

import "./CustomTabPanel.vue?vue&type=style&index=0&id=61daa2ce&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61daa2ce"]])

export default __exports__
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabPanel});
